<div class="crm-pagina">
  <header class="crm-topo">
    <div class="titulo">
      <h2><i class="fe-users"></i>CRM de clientes</h2>
      <p>Fila de trabalho: um segmento por vez, na ordem em que vale a pena chamar.</p>
    </div>
    <div class="topo-acoes">
      <nav class="alternador" aria-label="Visualização">
        <a (click)="abraQuadro()" href="javascript:void(0)"><i class="fe-grid"></i>Quadro</a>
        <a class="ativo" aria-current="page"><i class="fe-list"></i>Fila</a>
      </nav>
      <button type="button" class="btn-regras" (click)="regrasAbertas = true"><i class="fe-sliders"></i>Regras</button>
    </div>
  </header>

  <app-faixa-segmentos-crm [resumo]="resumo" [selecionado]="segmento.codigo"
                           (selecione)="selecioneSegmento($event)"></app-faixa-segmentos-crm>

  <section class="segmento" [style.--cor]="segmento.cor" [style.--fundo]="segmento.fundo">
    <div class="segmento-identidade">
      <span class="segmento-icone"><i [class]="segmento.icone"></i></span>
      <div>
        <h3>{{ segmento.nome }} <span>{{ numero(linhaDoSegmento.qtde) }}</span></h3>
        <p>{{ segmento.quem }}</p>
      </div>
    </div>

    <div class="segmento-acao">
      <span class="rotulo"><i class="fe-target"></i>O que fazer</span>
      <p>{{ segmento.acao }}</p>
    </div>

    <div class="segmento-numeros">
      <div>
        <strong>{{ numero(linhaDoSegmento.qtdeRecebeMensagem) }}</strong>
        <span>recebem campanha</span>
      </div>
      <div>
        <strong>{{ gastoDoSegmento }}</strong>
        <span>gastos em 90 dias</span>
      </div>
      <div>
        <strong>{{ numero(linhaDoSegmento.pedidos90d) }}</strong>
        <span>pedidos em 90 dias</span>
      </div>
    </div>

    <div class="segmento-botoes">
      <button type="button" class="btn-contorno" (click)="exporte()" [disabled]="!linhaDoSegmento.qtde">
        <i class="fe-download"></i> Exportar lista
      </button>
      <button type="button" class="btn-primario" (click)="crieCampanha()"
              [disabled]="criandoCampanha || !linhaDoSegmento.qtdeRecebeMensagem">
        <i [class]="criandoCampanha ? 'fe-loader gira' : 'fe-send'"></i>
        Criar campanha para este público
      </button>
    </div>
  </section>

  <div class="aviso" *ngIf="mensagem"><i class="fe-check"></i>{{ mensagem }}<button type="button" (click)="mensagem = ''" aria-label="Fechar aviso"><i class="fe-x"></i></button></div>
  <div class="aviso erro" *ngIf="erro"><i class="fe-alert-circle"></i>{{ erro }}</div>

  <section class="lista" [style.--cor]="segmento.cor" [style.--fundo]="segmento.fundo">
    <div class="lista-topo">
      <div class="busca">
        <i class="fe-search"></i>
        <input type="text" [placeholder]="'Buscar em ' + segmento.nome.toLowerCase()" [(ngModel)]="termoBusca" name="buscaFila"
               (keyup.enter)="busque(termoBusca)">
        <button type="button" *ngIf="termoBusca" class="limpar-busca" (click)="busque('')" aria-label="Limpar busca"><i class="fe-x"></i></button>
      </div>
      <span class="ordem"><i class="fe-trending-down"></i>{{ textoOrdem }}</span>
    </div>

    <div class="cabecalho-colunas">
      <span></span>
      <span>Cliente</span>
      <span>Último pedido</span>
      <span>Frequência</span>
      <span>{{ segmento.mostraAtraso ? 'Ritmo de compra' : 'Valor' }}</span>
      <span></span>
    </div>

    <div class="linhas"
         infiniteScroll
         [infiniteScrollDistance]="1.5"
         [infiniteScrollThrottle]="80"
         (scrolled)="carregueMais()">
      <app-cartao-contato-crm *ngFor="let contato of contatos; trackBy: trackPorId" modo="linha"
                              [contato]="contato" (ver)="verContato($event)" (mia)="abraMia($event)"></app-cartao-contato-crm>

      <ng-container *ngIf="carregando">
        <div class="linha-esqueleto" *ngFor="let i of [1,2,3,4,5,6]"><span class="a"></span><span class="b"></span><span class="c"></span></div>
      </ng-container>
    </div>

    <div class="vazio" *ngIf="!carregando && !contatos.length && !erro">
      <span class="vazio-icone"><i [class]="segmento.icone"></i></span>
      <strong>{{ termoBusca ? 'Nenhum cliente encontrado nesta busca.' : 'Ninguém em ' + segmento.nome.toLowerCase() + ' agora.' }}</strong>
      <p *ngIf="!termoBusca">{{ segmento.quem }}</p>
    </div>

    <div class="rodape-lista" *ngIf="contatos.length && !carregando">
      <button type="button" *ngIf="!fimDaLista" (click)="carregueMais()" [disabled]="carregandoMais">
        <i [class]="carregandoMais ? 'fe-loader gira' : 'fe-chevron-down'"></i>{{ carregandoMais ? 'Carregando' : 'Carregar mais' }}
      </button>
      <span *ngIf="fimDaLista">{{ numero(contatos.length) }} {{ contatos.length === 1 ? 'cliente' : 'clientes' }} nesta fila</span>
    </div>
  </section>
</div>

<app-regras-crm [aberto]="regrasAbertas" [regras]="regras" [editadasEm]="regrasEditadasEm"
                [defaultCalculadoEm]="defaultCalculadoEm"
                (fechar)="regrasAbertas = false" (salvou)="salvouRegras($event)"
                (recalculou)="recalculou()"></app-regras-crm>

<app-mensagem-mia-crm [aberto]="miaAberta" [contato]="contatoMia" (fechar)="miaAberta = false"></app-mensagem-mia-crm>
